import type { TranslationKey } from "../state/i18n";
import type { IconName } from "../components/icon/Icon";
import { keyFromSelector } from "i18next";

const META_VARIABLE_IDS = [
  "info.userId",
  "sys.user",
  "meta.location.longitude",
  "meta.location.latitude",
  "meta.registrationDate",
  "meta.guid",
  "meta.taskId",
  "meta.serialNumber",
  "info.formName",
  "info.summary",
] as const;

export type MetaVariableId = (typeof META_VARIABLE_IDS)[number];
export const META_VARIABLES: Record<MetaVariableId, { label: TranslationKey; icon: IconName }> = {
  "info.userId": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_USERNAME),
    icon: "user",
  },
  "sys.user": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_SUBMISSION_AUTHOR),
    icon: "user",
  },
  "meta.location.longitude": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_LOCATION_LONGITUDE),
    icon: "gpsLocation",
  },
  "meta.location.latitude": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_LOCATION_LATITUDE),
    icon: "gpsLocation",
  },
  "meta.registrationDate": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_SUBMISSION_DATE),
    icon: "calendar",
  },
  "meta.guid": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_GUID),
    icon: "server",
  },
  "meta.taskId": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_TASK_ID),
    icon: "clipboardCheck",
  },
  "meta.serialNumber": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_SERIAL_NUMBER),
    icon: "tag",
  },
  "info.formName": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_FORM_NAME),
    icon: "document",
  },
  "info.summary": {
    label: keyFromSelector(($) => $.PLACEHOLDER_VARIABLE_SUMMARY),
    icon: "documentText",
  },
} as const;

export const isMetaVariable = (value: string): value is MetaVariableId => META_VARIABLE_IDS.includes(value);
